<template>
  <div v-if="!unlocked" class="flex flex-col justify-center py-8 p-4 rounded-lg bg-gray-200 cursor-not-allowed">
    <div class="text-5xl">🔒</div>
  </div>
  <div v-else class="flex flex-col p-4 rounded-lg bg-gray-100 cursor-pointer">
    <div class="pb-2">{{ name }}</div>
    <div class="text-5xl">{{ icon }}</div>
  </div>
</template>

<script>
export default {
  name: 'ToolComponent',
  components: {
  },
  props: {
    name: String,
    icon: String,
    unlocked: Boolean,
  },
  emits: [
  ],
  data() {
    return {
    }
  },
  beforeMount() {
  },
  watch: {
  },
  methods: {
  },
  computed: {
  }
}
</script>